var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRslashpRslash = function SvgRslashpRslash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "926.313 214.192 12.578 12.384"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M926.852 214.723c.72-.708 1.677-.708 2.396 0l9.104 8.963c.72.708.72 1.652 0 2.36-.718.707-1.677.707-2.396 0l-9.104-8.964c-.719-.708-.719-1.652 0-2.36z",
    fill: "#F9D24B"
  })));
};
export default SvgRslashpRslash;